declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

type MetaPixelEventOptions = {
  /** Meta drops repeat events with the same name + eventID. */
  eventID?: string;
};

/**
 * Sends a Meta Pixel standard event. The pixel is loaded in index.html; `?.` keeps
 * this a no-op when an ad blocker stopped it from loading.
 */
export function trackMetaPixelEvent(
  event: string,
  params?: Record<string, unknown>,
  options?: MetaPixelEventOptions,
) {
  if (options) window.fbq?.("track", event, params ?? {}, options);
  else if (params) window.fbq?.("track", event, params);
  else window.fbq?.("track", event);
}
